<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current"
    viewBox="0 0 100 100"
  >
    <circle cx="50" cy="50" r="50" />
  </svg>
</template>
